import React, {
  useMemo,
} from 'react';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import map from 'lodash/map';
import ChargesIcon from 'core/icons/charges';
import ChargeMasterIcon from 'core/icons/chargeMaster';
import PaymentsIcon from 'core/icons/payments';
import StatementIcon from 'core/icons/statement';

const iconClassName = '!w-4 !h-4';
const tabClassName = '!p-2 !min-h-[48px] !normal-case !font-semibold';

const tabs = [{
  Icon: ChargesIcon,
  value: '/billing/claims',
  label: 'Charges',
}, {
  Icon: ChargeMasterIcon,
  value: '/billing/charge-master',
  label: 'Fee Schedule',
}, {
  Icon: PaymentsIcon,
  value: '/billing/payments',
  label: 'Payments & EOBs',
}, {
  Icon: StatementIcon,
  value: '/billing/statements',
  label: 'Statements',
}];

const valueMapping: Record<string, string> = {
  '/billing': '/billing/claims',
  '/billing/payments/patient-payments': '/billing/payments',
  '/billing/payments/eobs': '/billing/payments',
  '/billing/charge-master/cpt': '/billing/charge-master',
  '/billing/charge-master/custom': '/billing/charge-master',
};

const tabValueSet: Set<string> = new Set([
  ...map(tabs, 'value'),
  '/billing/payments/patient-payments',
  '/billing/payments/eobs',
  '/billing/charge-master/cpt',
  '/billing/charge-master/custom',
]);

export default function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();

  const isBillingMenuItem = tabValueSet.has(location.pathname);

  const tabValue = useMemo(() => (
    !isBillingMenuItem
      ? '/billing/claims'
      : valueMapping[location.pathname] ?? location.pathname
  ), [location]);

  return isBillingMenuItem ? (
    <Tabs
      className="!min-h-[48px] w-full border-b border-b-gray-200 px-4 populate-route-tabs"
      value={tabValue}
      onChange={(event, value: string) => {
        navigate(value);
      }}
    >
      {tabs.map(({ Icon, ...tabOptions }) => (
        <Tab
          key={tabOptions.value}
          className={tabClassName}
          iconPosition="start"
          {...tabOptions}
          icon={<Icon className={iconClassName} />}
        />
      ))}
    </Tabs>
  ) : null;
}
